(function () {
  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => [...r.querySelectorAll(s)];

  /* Mobile menu — slide drawer */
  const menuBtn = qs('[data-menu-toggle]');
  const mobileNav = qs('[data-mobile-nav]');
  const menuOverlay = qs('[data-menu-overlay]');
  const closeMenu = () => {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    mobileNav.setAttribute('inert', '');
    menuOverlay?.classList.remove('is-open');
    menuOverlay?.setAttribute('aria-hidden', 'true');
    menuBtn?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('st-menu-open');
    setTimeout(() => { mobileNav.hidden = true; }, 300);
  };
  const openMenu = () => {
    if (!mobileNav) return;
    mobileNav.hidden = false;
    mobileNav.removeAttribute('inert');
    requestAnimationFrame(() => {
      mobileNav.classList.add('is-open');
      mobileNav.setAttribute('aria-hidden', 'false');
      menuOverlay?.classList.add('is-open');
      menuOverlay?.setAttribute('aria-hidden', 'false');
      menuBtn?.setAttribute('aria-expanded', 'true');
      document.body.classList.add('st-menu-open');
    });
  };
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', () => {
      mobileNav.classList.contains('is-open') ? closeMenu() : openMenu();
    });
    menuOverlay?.addEventListener('click', closeMenu);
    qsa('[data-menu-link]', mobileNav).forEach((link) => link.addEventListener('click', closeMenu));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) closeMenu();
    });
  }

  /* Sticky header (opt-in via Header section settings) */
  const stHeader = qs('[data-header]');
  if (stHeader && stHeader.hasAttribute('data-sticky')) {
    let hdrTick = false;
    const onHdrScroll = () => {
      if (hdrTick) return;
      hdrTick = true;
      requestAnimationFrame(() => {
        stHeader.classList.toggle('is-stuck', window.scrollY > 8);
        hdrTick = false;
      });
    };
    window.addEventListener('scroll', onHdrScroll, { passive: true });
    onHdrScroll();
  }

  /* Cart drawer */
  const drawer = qs('#CartDrawer');
  const openCart = () => {
    if (!drawer) return;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };
  const closeCart = () => {
    if (!drawer) return;
    drawer.hidden = true;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };
  qsa('[data-cart-open]').forEach((el) => el.addEventListener('click', openCart));
  qsa('[data-cart-close]').forEach((el) => el.addEventListener('click', closeCart));

  /* Product gallery */
  const gallery = qs('[data-product-gallery]');
  if (gallery) {
    const main = qs('[data-main-image]', gallery);
    qsa('[data-gallery-thumb]', gallery).forEach((btn, i) => {
      if (i === 0) btn.classList.add('is-active');
      btn.addEventListener('click', () => {
        qsa('[data-gallery-thumb]', gallery).forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        if (main && btn.dataset.src) {
          main.src = btn.dataset.src;
          if (btn.dataset.alt) main.alt = btn.dataset.alt;
        }
      });
    });
  }

  const routes = window.ST_ROUTES || {};
  const cartAddUrl = routes.cart_add || (window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js');
  const checkoutUrl = routes.checkout || '/checkout';

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      if (Number(count) > 0) el.hidden = false;
      else el.hidden = true;
    });
  }

  function formatMoneyFromCart(cents, currency) {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format || '{{amount}}');
    }
    const n = (Number(cents) / 100).toFixed(2);
    return currency === 'EUR' ? `€${n.replace('.', ',')}` : `${currency} ${n}`;
  }

  async function refreshCartDrawer() {
    const drawer = qs('[data-cart-drawer]');
    const body = qs('[data-cart-contents]');
    const totalEl = qs('[data-cart-total]', drawer || document);
    if (!body) return;
    try {
      const res = await fetch('/cart.js');
      if (!res.ok) return;
      const cart = await res.json();
      updateCartCount(cart.item_count);
      if (cart.item_count === 0) {
        body.innerHTML = `<p class="st-cart-drawer__empty">${body.dataset.emptyMsg || 'Your cart is empty.'}</p>`;
        if (totalEl) totalEl.innerHTML = '<strong></strong>';
        return;
      }
      const esc = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
      const propsHtml = (item) => {
        const props = item.properties || {};
        const lines = Object.keys(props)
          .filter((k) => k && !String(k).startsWith('_') && props[k] != null && props[k] !== '')
          .map((k) => `<p class="st-cart-drawer__prop">${esc(k)}: ${esc(String(props[k]).slice(0, 80))}</p>`)
          .join('');
        return lines;
      };
      body.innerHTML = `<ul class="st-cart-drawer__lines">${cart.items.map((item) => {
        const props = item.properties || {};
        const ref = props._pz_preview_ref || props['Ref diseño'] || '';
        let imgSrc = item.image || '';
        if (ref) {
          try {
            const preview = sessionStorage.getItem(`st-pz-preview-${ref}`);
            if (preview) imgSrc = preview;
          } catch (_) {}
        }
        return `
        <li class="st-cart-drawer__line" data-pz-ref="${esc(ref)}">
          ${imgSrc ? `<img src="${esc(imgSrc)}" alt="" width="64" height="64" loading="lazy">` : ''}
          <div>
            <a href="${esc(item.url)}">${esc(item.product_title)}</a>
            ${propsHtml(item)}
            <p>${item.quantity} × ${formatMoneyFromCart(item.final_line_price, cart.currency)}</p>
          </div>
        </li>`;
      }).join('')}</ul>`;
      if (totalEl) totalEl.innerHTML = `<strong>${formatMoneyFromCart(cart.total_price, cart.currency)}</strong>`;
    } catch (_) {}
  }

  async function postProductForm(form, { checkout = false } = {}) {
    const fd = new FormData(form);
    const res = await fetch(cartAddUrl, {
      method: 'POST',
      body: fd,
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || 'Could not add to cart');
    }
    const data = await res.json();
    const cartRes = await fetch('/cart.js');
    const cart = cartRes.ok ? await cartRes.json() : null;
    updateCartCount(cart?.item_count ?? 1);
    await refreshCartDrawer();
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
    if (checkout) {
      window.location.href = checkoutUrl;
      return;
    }
    openCart();
  }

  /* Collection cards — AJAX add */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.st-card__form');
    if (!form) return;
    e.preventDefault();
    const checkout = e.submitter?.dataset?.cartAction === 'buy';
    const buttons = form.querySelectorAll('button');
    buttons.forEach((button) => { button.disabled = true; });
    try {
      await postProductForm(form, { checkout });
      if (!checkout) buttons.forEach((button) => { button.disabled = false; });
    } catch {
      buttons.forEach((button) => { button.disabled = false; });
      form.submit();
    }
  });

  /* Cookie consent */
  const cookie = qs('#CookieConsent');
  if (cookie && !localStorage.getItem('st-cookie')) {
    cookie.hidden = false;
    qs('[data-cookie-accept]', cookie)?.addEventListener('click', () => {
      localStorage.setItem('st-cookie', '1');
      cookie.hidden = true;
    });
    qs('[data-cookie-decline]', cookie)?.addEventListener('click', () => {
      localStorage.setItem('st-cookie', '0');
      cookie.hidden = true;
    });
  }

  function formatMoney(cents, currency) {
    const n = (Number(cents) / 100).toFixed(2);
    const sym = currency === 'EUR' ? '€' : currency + ' ';
    return sym === '€' ? `€${n.replace('.', ',')}` : `${sym}${n}`;
  }

  async function addToCart(variantId, quantity, checkout = false, properties) {
    const payload = { id: variantId, quantity };
    if (properties && typeof properties === 'object') payload.properties = properties;
    const res = await fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error('Cart error');
    const data = await res.json();
    const cartRes = await fetch('/cart.js');
    const cart = cartRes.ok ? await cartRes.json() : null;
    updateCartCount(cart?.item_count ?? 1);
    await refreshCartDrawer();
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
    if (checkout) {
      window.location.href = checkoutUrl;
      return data;
    }
    openCart();
    return data;
  }

  /* Product page — qty, pills, sticky */
  const productForm = qs('#ProductForm');
  const pdpPage = qs('[data-product-page]');
  if (productForm && pdpPage) {
    const qtyInput = qs('[data-qty-input]', productForm);
    qs('[data-qty-minus]', productForm)?.addEventListener('click', () => {
      qtyInput.value = Math.max(1, Number(qtyInput.value) - 1);
    });
    qs('[data-qty-plus]', productForm)?.addEventListener('click', () => {
      qtyInput.value = Number(qtyInput.value) + 1;
    });

    qsa('[data-option-index]', productForm).forEach((wrap) => {
      const idx = Number(wrap.dataset.optionIndex);
      const select = productForm.querySelectorAll('[data-option-select]')[idx];
      qsa('[data-option-value]', wrap).forEach((pill) => {
        pill.addEventListener('click', () => {
          qsa('[data-option-value]', wrap).forEach((p) => p.classList.remove('is-active'));
          pill.classList.add('is-active');
          if (select) {
            select.value = pill.dataset.optionValue;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    });

    const variantsEl = qs('[data-product-variants]');
    let variants = [];
    if (variantsEl) {
      try { variants = JSON.parse(variantsEl.textContent); } catch (_) {}
    }
    const variantInput = qs('[data-variant-id]', productForm);
    const updateVariant = () => {
      if (!variants.length) return;
      const opts = [...productForm.querySelectorAll('[data-option-select]')].map((s) => s.value);
      const match = variants.find((v) => {
        const o = [v.option1, v.option2, v.option3].filter(Boolean);
        return opts.every((val, i) => o[i] === val);
      });
      if (match && variantInput) variantInput.value = match.id;
    };
    productForm.querySelectorAll('[data-option-select]').forEach((s) => s.addEventListener('change', updateVariant));

    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const action = e.submitter?.dataset?.cartAction || 'add';
      const btn = e.submitter;
      if (btn) btn.disabled = true;
      try {
        updateVariant();
        await postProductForm(productForm, { checkout: action === 'buy' });
      } catch (err) {
        alert(err.message || 'Error al añadir al carrito');
      } finally {
        if (btn) btn.disabled = false;
      }
    });

    const sticky = qs('[data-pdp-sticky]');
    if (sticky) {
      const show = () => {
        const rect = productForm.getBoundingClientRect();
        sticky.hidden = rect.bottom > window.innerHeight * 0.6;
      };
      let stickyTick = false;
      const onStickyScroll = () => {
        if (stickyTick) return;
        stickyTick = true;
        requestAnimationFrame(() => { show(); stickyTick = false; });
      };
      window.addEventListener('scroll', onStickyScroll, { passive: true });
      show();
      qs('[data-sticky-add]', sticky)?.addEventListener('click', () => {
        productForm.querySelector('[data-cart-action="add"]')?.click();
      });
      qs('[data-sticky-buy]', sticky)?.addEventListener('click', () => {
        productForm.querySelector('[data-cart-action="buy"]')?.click();
      });
    }
  }

  /* Product recommendations carousel */
  qsa('[data-product-recos]').forEach((root) => {
    const track = qs('[data-recos-track]', root);
    const nav = qs('[data-recos-nav]', root);
    if (!track || track.classList.contains('st-recos__track--grid')) return;

    const updateNav = () => {
      if (!nav) return;
      const scrollable = track.scrollWidth > track.clientWidth + 4;
      nav.hidden = !scrollable;
    };
    updateNav();
    window.addEventListener('resize', updateNav);

    qs('[data-recos-prev]', root)?.addEventListener('click', () => {
      track.scrollBy({ left: -track.clientWidth * 0.85, behavior: 'smooth' });
    });
    qs('[data-recos-next]', root)?.addEventListener('click', () => {
      track.scrollBy({ left: track.clientWidth * 0.85, behavior: 'smooth' });
    });
  });
})();
